import React from 'react';
import PropTypes from 'prop-types';

import { withTranslation } from 'react-i18next';

// import ScrollArea from 'react-scrollbar';
import { filter, map, includes, size } from 'lodash';
import classNames from 'classnames';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Label from 'reactstrap/lib/Label';
import TabPane from 'reactstrap/lib/TabPane';
import TabContent from 'reactstrap/lib/TabContent';
import Button from 'reactstrap/lib/Button';
import Media from 'reactstrap/lib/Media';
import NavLink from 'reactstrap/lib/NavLink';
import DropdownItem from 'reactstrap/lib/DropdownItem';
// import ScrollAreaButtons from '../../UI/ScrollAreaButtons';

import CustomDropdown from '../../Components/Components/CustomDropdown';
import ScrollAreaWrapper from '../../Components/ScrollAreaWrapper';

import * as constants from '../../../../../constants/constants';
import { getNewHelpSections } from '../../../../../actions/member';
import { connect } from 'react-redux';
import TextEditor from '../../../TextEditor/TextEditor';

// const RulesPage = ({ toggleHelpTab, helpTab, scrollPos, scroll, handleScroll, updateScrollPos, setScrollRef }) => {

class RulesPage extends React.Component {
  static propTypes = {
    userSettings: PropTypes.shape(),
    uid: PropTypes.string,
    title: PropTypes.string,
    modalFlag: PropTypes.bool,
    getNewHelpSectionsFunc: PropTypes.func.isRequired,
    newHelps: PropTypes.shape(),
  }

  static defaultProps = {
    uid: '',
    errorNotification: '',
    title: null,
    modalFlag: false,
  }

  constructor(props) {
    super(props);
    const { t } = props;
    this.state = {
      helpTab: '1',
      typeFilterOpen: false,
      pageHeight: 0,
      pageWidth: 0,
    };
    this.scrollAreaRef = React.createRef();
  }

  componentWillMount() {

  }

  componentDidMount() {
    const { getNewHelpSectionsFunc } = this.props;
    getNewHelpSectionsFunc();

    window.scrollTo(0, 0);

    const updatePageHeight = () => {
      const height = window.innerHeight;
      const width = window.innerWidth;
      this.setState({ pageHeight: height, pageWidth: width });
    };

    // Call the function initially to get the initial page height
    updatePageHeight();

    // Attach an event listener to window resize to update the height if the page changes
    window.addEventListener('resize', updatePageHeight);
  }

  componentWillUnmount() {
    try {
      window.removeEventListener('resize', this.updatePageHeight);
    } catch (err) {
      console.log('err componentWillUnmount');
    }
  }

  componentDidUpdate(prevProps) {
    const { i18n, newHelps } = this.props;

    if (
      prevProps.i18n.language !== i18n.language ||
      prevProps.newHelps !== newHelps
    ) {
      this.handleHelpData(this.props);
    }
  }

  handleHelpData = (props) => {
    const { i18n, newHelps } = props;
    const curLang = i18n.language || constants.sendLanguage.lv;

    if (newHelps && newHelps[curLang] && curLang) {
      const helpSectionData = JSON.parse(newHelps[curLang].helpSection) || [];

      this.setState({
        helpData: helpSectionData,
        helpTab: helpSectionData[0]?.id || null,
        customToggle: helpSectionData[0]
          ? `${helpSectionData[0].orderId}${helpSectionData[0].title}`
          : ""
      });
    } else {
      this.setState({ helpData: [] });
    }
  }

  toggleHelpTab = (tab, index, isChild) => {
    const { playButtonSound } = this.props;
    const { helpTab, helpTabChild, helpData } = this.state;

    this.scrollAreaRef.current.scrollTop = 0;

    playButtonSound();

    if (!isChild) {
      const selectedTab = helpData[index];

      if (selectedTab.subsections) {
        if (selectedTab.content && selectedTab.content !== '<p></p>\n') {
          if (helpTab !== tab) {
            this.setState({
              helpTabParent: tab,
              helpTab: tab,
              helpTabChild: null,
            });
          }
        } else if (helpTab !== tab) {
          this.setState({
            helpTabParent: tab,
            helpTab: selectedTab.subsections[0].id,
            helpTabChild: selectedTab.subsections[0].id,
          });
        }
      } else if (helpTab !== tab) {
        this.setState({
          helpTab: tab,
          helpTabParent: null,
          helpTabChild: null,
        });
      }
    } else if (helpTabChild !== tab) {
      this.setState({
        helpTab: tab,
        helpTabChild: tab,
      });
    }
  }

  updateScrollPos = (val) => {
    this.setState({ scrollPos: val.topPosition || 0 });
  }

  scroll = (newVal) => {
    this.messagesScrollbar.scrollYTo(newVal);
  }

  setScrollRef = (el) => {
    this.messagesScrollbar = el;
  }

  toggleTypeFilter = () => {
    this.setState(prevState => ({
      filterOpen: false,
      typeFilterOpen: !prevState.typeFilterOpen,
    }));
  }

  toggleType = (key) => {
    const { helpTab } = this.state;
    if (key && helpTab !== key) {
      this.setState({
        helpTab: key,
      });
      this.scrollAreaRef.current.scrollTop = 0;
    }
  }

  render() {
    const {
      t,
      toggleHelp,
      i18n,
      title,
      modalFlag,
      newHelps,
    } = this.props;

    const {
      scrollPos,
      typeFilterOpen,
      pageHeight,
      pageWidth,
    
      helpData,
      helpTab,
      helpTabChild,
      helpTabParent,
      customToggle,
    } = this.state;

    return (
      <div className="zole-rules-container">
        <Row className="zole-rules-page">
          {
            title && (
              <Col md="12">
                <h1 className="zole-rules-page-title">{t('menu.' + title)}</h1>
              </Col>
            )
          }
          <Col sm="12" className='zole-rules-page-mobile-header'>
            <div className="zole-rules-page-header-tab">
              {customToggle && (
                <CustomDropdown
                  toggle={customToggle}
                  toggleFunc={this.toggleTypeFilter}
                  isOpen={typeFilterOpen}
                  menu={(
                    <>
                      {map(helpData, item => (
                        <>
                          <DropdownItem key={item.id} onClick={() => this.toggleType(item.id)}>
                            {`${item.orderId}${t(item.title)}`}
                          </DropdownItem>
                          {item.subsections && map(item.subsections, subItem => (
                            <DropdownItem key={subItem.id} onClick={() => this.toggleType(subItem.id)}>
                              {`${subItem.orderId}${t(subItem.title)}`}
                            </DropdownItem>
                          ))}
                        </>
                      ))}
                    </>
                    )}
                  inlineMenuClassName={`landing-help-page-dropdown-list ${modalFlag && 'menu-rule-drop-down'}`}
                />
              )}
            </div>
          </Col>

          {size(helpData) > 0 && helpTab && map(helpData, tab => (
            (helpTab === tab.id) ? (
              <Col md="12">
                <h2 className="zole-rules-page-sub-title">{tab?.title}</h2>
              </Col>
            ) : (
              tab.subsections && size(tab.subsections) > 0 && map(tab.subsections, subItem => (
                (helpTab === subItem.id) ? (
                  <Col md="12">
                    <h2 className="zole-rules-page-sub-title">{subItem?.title}</h2>
                  </Col>
                ) : (null)
              ))
            )
          ))}
          <Col sm="3" className="zole-rules-page-header">
            <Row className="zole-rules-page-header-tab">
              <div
                className={`contact-support-chat-body-scroll-area contact-support-chat-body-scroll-area-content zole-rules-page-body-scroll-area ${!modalFlag && 'contact-support-chat-body-scroll-area-limited'}`}
                show
                rightOffset={5}
                topOffset={0}
                bottomOffset={0}
              >
                {helpData && helpData.map((tab, index) => (
                  <>
                    <Col sm={{ size: 10, offset: 1 }} className="zole-rules-page-tab">
                      <div className={`zole-rules-page-tab-wrapper ${helpTab === tab.id && 'active'}`}>
                        <NavLink
                          className={`zole-rules-page-header-link ${helpTab === tab.id && 'zole-rules-page-header-link-active'}`}
                          onClick={() => this.toggleHelpTab(tab.id, index, false)}
                        >
                          {`${tab.orderId}${tab.title}`}
                        </NavLink>
                      </div>
                    </Col>
                    {helpTabParent && helpTabParent === tab.id && tab.subsections ? (
                      <>
                        {tab.subsections.map((childTab, index2) => (
                          <Col sm={{ size: 10, offset: 2 }} className="zole-rules-page-tab zole-rules-page-tab-child">
                            <div className={`zole-rules-page-tab-wrapper ${helpTabChild === childTab.id && 'active'}`}>
                              <NavLink
                                className={`zole-rules-page-header-link ${helpTabChild === childTab.id && 'zole-rules-page-header-link-active'}`}
                                onClick={() => this.toggleHelpTab(childTab.id, index2, true)}
                              >
                                {`${childTab.orderId}${childTab.title}`}
                              </NavLink>
                            </div>
                          </Col>
                        ))}
                      </>
                    ) : (null)}
                  </>
                ))}
              </div>
            </Row>
          </Col>
          <div sm="9" className="col-sm-9 zole-rules-page-content" style={{ paddingRight: 5 }} ref={this.scrollAreaRef} >
            <TabContent className="zole-rules-page-content-tab" activeTab={helpTab}>
              {map(helpData, item => (
                <>
                  <TabPane tabId={item.id}>
                    <div className={classNames({"help-content": !modalFlag, "menu-help-content": modalFlag})}>
                      <div>
                        <Row>
                          <Col className="zole-rules-page-content-wrapper">
                            <TextEditor viewEditorState={item.content} addEditorClassName="text-rules img-rules-new" originalPadding readOnly />
                          </Col>
                        </Row>
                      </div>
                    </div>
                    {
                      !modalFlag && (
                        <div className="mobile-help-content">
                          <Row>
                            <Col className="zole-rules-page-content-wrapper">
                              <ScrollAreaWrapper
                                show
                                rightOffset={2}
                                topOffset={0}
                                bottomOffset={0}
                                vertical={true}
                                height={pageWidth <= pageHeight ? pageHeight - 250 : pageHeight - 200}
                              >
                                <TextEditor viewEditorState={item.content} addEditorClassName="text-rules img-rules-new" originalPadding readOnly />
                              </ScrollAreaWrapper>
                            </Col>
                          </Row>
                        </div>
                      )
                    }
                  </TabPane>
                  {item.subsections && item.subsections.map(subTab => (
                    <>
                      <TabPane key={subTab.id} tabId={subTab.id}>
                        <div
                          className="contact-support-chat-body-scroll-area"
                          contentClassName="contact-support-chat-body-scroll-area-content"
                        >
                          <Row>
                            <Col className="rules-page-content-wrapper">
                              <TextEditor viewEditorState={subTab.content} addEditorClassName="text-rules img-rules-new" originalPadding readOnly />
                            </Col>
                          </Row>
                        </div>
                      </TabPane>
                      {!modalFlag && (
                        <div className="mobile-help-content">
                          <Row className="m-0">
                            <Col className="zole-rules-page-content-wrapper">
                              <ScrollAreaWrapper
                                show
                                rightOffset={2}
                                topOffset={0}
                                bottomOffset={0}
                                vertical
                                height={pageWidth <= pageHeight ? pageHeight - 250 : pageHeight - 200}
                              >
                                <TextEditor viewEditorState={subTab.content} addEditorClassName="text-rules img-rules-new" originalPadding readOnly />
                              </ScrollAreaWrapper>
                            </Col>
                          </Row>
                        </div>
                      )}
                    </>
                  ))}
                </>
              ))}

            </TabContent>

          </div>
        </Row>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  newHelps: state.member.newHelps,
});

const mapDispatchToProps = {
  getNewHelpSectionsFunc: getNewHelpSections
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(RulesPage));
